import React, { useEffect, useRef, useState } from 'react'
import { LuTriangleAlert, LuX } from 'react-icons/lu'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { toast } from 'react-toastify';
import nameIcon from "../../images/forms/name.svg";
import emailIcon from "../../images/forms/email.svg";
import phoneIcon from "../../images/forms/phone.svg";
import yearIcon from "../../images/forms/year.svg";
import graduationIcon from "../../images/forms/graduation.svg";
import collegeIcon from "../../images/forms/college.svg";
import universityIcon from "../../images/forms/university.svg";
import locationIcon from "../../images/forms/location.svg";
import degreeIcon from "../../images/forms/degree.svg";
import departmentIcon from "../../images/forms/department.svg";
import interestIcon from "../../images/forms/interested.svg";
import experienceIcon from "../../images/forms/experience.svg";
import aimIcon from "../../images/forms/aim.svg";
import challengeIcon from "../../images/forms/challenge.svg";
import sessionIcon from "../../images/forms/session.svg";
import consentIcon from "../../images/forms/consent.svg";
import axios from 'axios';
import API from '../../../utils/API';
import ack from "../../images/forms/ack.webp";
import LoadLottie from '../loadLottie';
import Tick from "../../../json/tick-mark.json";
import Error from "../../../json/error.json";

export default function SurgeStudentsForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [year, setYear] = useState("");

    const [gradution, setGradution] = useState("");
    const [collegeName, setCollegeName] = useState("");
    const [universityName, setUniversityName] = useState("");
    const [location, setLocation] = useState("");

    const [degree, setDegree] = useState("");
    const [department, setDepartment] = useState("");
    const [interestedTrack, setInterestedTrack] = useState("");
    const [experience, setExperience] = useState("");

    const [aim, setAim] = useState("");
    const [challenge, setChallenge] = useState("");
    const [session, setSession] = useState("");
    const [consent, setConsent] = useState("");

    const [acknowledge, setAcknowledge] = useState(false);

    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [numberError, setNumberError] = useState("");
    const [yearError, setYearError] = useState("");

    const [gradutionError, setGradutionError] = useState("");
    const [collegeNameError, setCollegeNameError] = useState("");
    const [universityNameError, setUniversityNameError] = useState("");
    const [locationError, setLocationError] = useState("");

    const [degreeError, setDegreeError] = useState("");
    const [departmentError, setDepartmentError] = useState("");
    const [interestedTrackError, setInterestedTrackError] = useState("");
    const [experienceError, setExperienceError] = useState("");

    const [aimError, setAimError] = useState("");
    const [challengeError, setChallengeError] = useState("");
    const [sessionError, setSessionError] = useState("");
    const [consentError, setConsentError] = useState("");


    const [countryCode, setCountryCode] = useState({});

    const [isStep1, setIsStep1] = useState(false);
    const [isStep2, setIsStep2] = useState(false);
    const [isStep3, setIsStep3] = useState(false);
    const [isStep4, setIsStep4] = useState(false);

    const [isClicked, setIsClicked] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isPaymentFailed, setIsPaymentFailed] = useState(false);
    const [timeLeft, setTimeLeft] = useState(30);
    const timerRef = useRef(null);

    const [scriptLoaded, setScriptLoaded] = useState(false);

    const invalidCharsRegex = /^[\s\u200B-\u200D\uFEFF]+$/;

    const handleStep1 = async () => {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const phoneWithoutPlus = number.startsWith(`+${countryCode?.dialCode}`)
                ? number.slice(countryCode?.dialCode?.length + 1)
                : number;

            // --- Regex Helpers ---
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;

            // --- Name Validation ---
            if (!name.trim()) return setNameError("Please fill in this");
            if (invalidCharsRegex.test(name)) return setNameError("Invalid special characters");

            // --- Email Validation ---
            if (!email) return setEmailError("Please fill in this");
            if (invalidCharsRegex.test(email)) return setEmailError("Invalid special characters");
            if (!emailRegex.test(email)) return setEmailError("Hmm... that email doesn't look right");

            // --- Phone Validation ---
            let isValid = false;
            try {
                const parsedPhone = phoneUtil.parse(number, countryCode?.iso2);
                isValid = phoneUtil.isValidNumber(parsedPhone);
            } catch {
                isValid = false;
            }
            if (!isValid || !phoneWithoutPlus) {
                return setNumberError("Hmm... that number doesn't look right");
            }

            // --- Linkedin Validation ---
            if (!year.trim()) return setYearError("Please fill in this");
            if (invalidCharsRegex.test(year)) return setYearError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SUBMIT, {
                email,
                name,
                phone: number,
                yos: year,
            });
            if (data?.statusCode === 200) {
                setIsStep1(true)
            }
            setIsStep1(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep2 = async () => {
        try {

            // --- Graduation year Validation ---
            if (!gradution.trim()) return setGradutionError("Please fill in this");
            if (invalidCharsRegex.test(gradution)) return setGradutionError("Invalid special characters");

            // --- College name Validation ---
            if (!collegeName.trim()) return setCollegeNameError("Please fill in this");
            if (invalidCharsRegex.test(collegeName)) return setCollegeNameError("Invalid special characters");

            // --- University name Validation ---
            if (!universityName.trim()) return setUniversityNameError("Please fill in this");
            if (invalidCharsRegex.test(universityName)) return setUniversityNameError("Invalid special characters");

            // --- Linkedin Validation ---
            if (!location.trim()) return setLocationError("Please fill in this");
            if (invalidCharsRegex.test(location)) return setLocationError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SUBMIT, {
                email,
                yog: gradution,
                clgName: collegeName,
                uniName: universityName,
                location: location
            });

            if (data?.statusCode === 200) {
                setIsStep2(true)
            }
            setIsStep2(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep3 = async () => {
        try {

            // --- Degree Validation ---
            if (!degree.trim()) return setDegreeError("Please fill in this");
            if (invalidCharsRegex.test(degree)) return setDegreeError("Invalid special characters");

            // --- Departmenr name Validation ---
            if (!department.trim()) return setDepartmentError("Please fill in this");
            if (invalidCharsRegex.test(department)) return setDepartmentError("Invalid special characters");

            // --- Interested track Validation ---
            if (!interestedTrack.trim()) return setInterestedTrackError("Please Select atleast one option...");

            // --- Experience Validation ---
            if (!experience.trim()) return setExperienceError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SUBMIT, {
                email,
                degType: degree,
                dept: department,
                track: interestedTrack,
                expInTrack: experience
            });

            if (data?.statusCode === 200) {
                setIsStep3(true)
            }
            setIsStep3(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep4 = async () => {
        try {

            // --- Aim Validation ---
            if (!aim.trim()) return setAimError("Please Select atleast one option...");

            // --- Challenge name Validation ---
            if (!challenge.trim()) return setChallengeError("Please Select atleast one option...");

            // --- Session Validation ---
            if (!session.trim()) return setSessionError("Please Select atleast one option...");

            // --- Consent Validation ---
            if (!consent.trim()) return setConsentError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SUBMIT, {
                email,
                aim,
                challenge,
                session,
                consent: consent === "No" ? false : true
            });

            if (data?.statusCode === 200) {
                setIsStep4(true)
            }
            setIsStep4(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep5 = async () => {
        try {

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SUBMIT, {
                email,
                ack: acknowledge
            });

            if (data?.statusCode === 200) {
                if (acknowledge) {
                    handleSubmit()
                } else {
                    setIsSuccess(true)
                }
            }
            if (acknowledge) {
                handleSubmit()
            } else {
                setIsSuccess(true)
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    // const handleSubmitPayment = async () => {
    //     try {

    //         // --- API Call ---
    //         const { data } = await axios.post(API.BASE_URL + API.UPDATE_PAYMENT, {
    //             email,
    //         });

    //         if (data?.statusCode === 200) {
    //             setIsSuccess(true)
    //         }
    //         const createTask = await axios.post(API.TASK_BASE_URL + API.CREATE_TASK,
    //             {
    //                 projectId: 10068,
    //                 title: name,
    //                 description: JSON.stringify({
    //                     name,
    //                     email,
    //                     phone: number,
    //                     year,
    //                     graduation: gradution,
    //                     collegeName,
    //                     universityName,
    //                     location,
    //                     degree,
    //                     department,
    //                     interestedTrack,
    //                     experience,
    //                     aim,
    //                     challenge,
    //                     session,
    //                     consent,
    //                     acknowledge,
    //                     payment: "Yes",
    //                     workfast: ""
    //                 }, null, 2),
    //                 createdUser: 85155329,
    //                 assignee: [],
    //                 stage: "Open",
    //                 status: "Open",
    //                 tag: "Open"
    //             },
    //             {
    //                 headers: {
    //                     form: "bookdemo",
    //                 },
    //             });
    //         console.log(createTask);
    //         setIsSuccess(true)
    //     } catch (err) {
    //         toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
    //             position: "top-right",
    //             autoClose: 3000,
    //         });
    //     } finally {
    //         setIsClicked(false)
    //     }
    // };

    const loadScript = async (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    }

    const handleSubmit = async () => {
        try {
            setIsClicked(true)
            const params = new URLSearchParams({
                email,
                name,
                number,
                year,
                graduation: gradution,
                collegeName,
                universityName,
                location,
                degree,
                department,
                interestedTrack,
                experience,
                aim,
                challenge,
                session,
                consent,
                acknowledge,
            });

            const { data } = await axios.post(
                API.PAYMENT_BASE_URL + API.PAYMENT,
                {
                    userCount: 1, subscriptionType: "monthly", pageType: "surgeStudent", packageType: "", redirectLink: `${window.location.origin}/surge-students/payment-checking?${params.toString()}`,
                    // userCount: 1, subscriptionType: "monthly", pageType: "eventPrice", packageType: "testing", redirectLink: `${window.location.origin}/surge-students/payment-checking?${params.toString()}`,
                },
            );
            if (data === "nodomain") {
                alert("Domain url wrong");
                window.location.href = "/404";
            }
            else if (data?.statusCode === 200) {
                razorPayment(data?.data);
            }
        } catch (err) {
            var statusCode = err?.response?.status;
            console.log(statusCode);
        }
    };

    const razorPayment = async (purchaseData) => {
        if (!scriptLoaded) {
            await loadScript('https://checkout.razorpay.com/v1/checkout.js'); // Load the Razorpay script dynamically
            setScriptLoaded(true);
        }

        const options = {
            key: API.KEY,
            description: "Surge Students",
            order_id: purchaseData?.id,
            callback_url: API.PAYMENT_BASE_URL + API.PAYMENT_SUCCESS,
            // handler: async (response) => {
            //     handleSubmitPayment()
            //     const res = await axios.post(API.PAYMENT_BASE_URL + API.PAYMENT_SUCCESS, {
            //         ...response,
            //     }, {
            //         headers: { "x-axios-request": "true" }
            //     });
            //     if (res.data.success) {
            //         // window.location.href = res.data.redirectUrl;
            //     }
            // },
            notes: {
                purchaseId: purchaseData?.id
            },
            prefill: {
                email: email,
                contact: number,
                // 'method': 'card' //netbanking|card|upi|wallet
            },
            modal: {
                ondismiss: async () => {
                    await axios.post(API.PAYMENT_BASE_URL + API.PAYMENT_CLOSED, { id: purchaseData?.id });
                    setIsPaymentFailed(true)
                    setIsSuccess(true)
                    setIsClicked(false)
                },
            },
            theme: {
                color: "#560095"
            },
            config: {
                display: {
                    hide: [
                        { method: 'paylater' },
                        { method: 'emi' },
                        { method: 'cardless_emi' },
                        // { method: 'upi' },
                    ],
                }
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };

    const tracks = [
        "Software Development Track",
        "UI/UX & Product Design Track",
        "QA & Testing Track",
        "Data Science & Analytics Track",
        "AI & Machine Learning Track",
        "Cybersecurity & Ethical Hacking Track",
        "Cloud & DevOps Track",
        "Product Management Track",
        "Digital Marketing & Growth Track",
        "Content Creation & Personal Branding Track",
        "Business & Entrepreneurship Track",
        "Mechanical Engineering Domain Track",
        "Civil Engineering Domain Track",
        "Electrical & Electronics (EEE) Domain Track",
        "Electronics & Communication (ECE) Domain Track",
        "Instrumentation & E&I Domain Track",
        "Chemical Engineering Domain Track",
        "Biotech & Life Sciences Domain Track",
        "Robotics & Mechatronics Track",
        "Architecture & Interior Design Track",
        "Arts & Humanities Career Track",
        "Science (Physics / Chemistry / Math) Career Track",
        "Commerce, Finance & Accounting Track",
        "Creator Economy & Influencer Track",
    ];

    const years = [
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
    ];

    useEffect(() => {
        if (isSuccess) {
            // reset timer every time popup opens
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        if (isPaymentFailed) {
                            setIsSuccess(false);
                            setIsPaymentFailed(false);
                        } else {
                            window.location.href = "/"
                        }
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);

    return (
        <div className='p-[20px] md:p-[50px] h-screen flex flex-col gap-[30px]'>
            <div>
                <div className='flex justify-between gap-[14px]'>
                    <div>
                        <h1 className='text-[#080808] font-semibold text-[20px] md:text-[28px]'>Students Registration Form | Surge Students</h1>
                        <h2 className='mt-[7px] text-[16px] md:text-[22px] font-normal'>Fill out the form below to reserve your spot.</h2>
                    </div>
                    <LuX className='text-[20px] md:text-[24px] mt-[5px]' onClick={() => { window.location.href = "/" }} />
                </div>
                <div className="grid gap-[10px] py-[10px] grid-cols-5 mt-[10px] md:mt-[20px]">
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF3B30] transition-all duration-500 ease-in-out ${isStep1 ? "w-full rounded-full" : "w-1/2 rounded-l-full"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF9500] transition-all duration-500 ease-in-out ${isStep2 ? "w-full rounded-full" : isStep1 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#34C759] transition-all duration-500 ease-in-out ${isStep3 ? "w-full rounded-full" : isStep2 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${isStep4 ? "w-full rounded-full" : isStep3 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${(isSuccess && !isPaymentFailed) ? "w-full rounded-full" : isStep4 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                </div>
            </div>
            <div className={`flex justify-start items-center w-full overflow-hidden h-full`}>
                {/* ---- Step 1 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={nameIcon} alt='nameIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Full Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={name} placeholder='Enter your full name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setName(e.target.value); setNameError('') }} />
                        </div>
                        {nameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{nameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={emailIcon} alt='emailIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Email ID <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='email' value={email} placeholder='Enter your Email ID' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setEmail(e.target.value); setEmailError('') }} />
                        </div>
                        {emailError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{emailError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FFCC0026] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={phoneIcon} alt='phoneIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Phone No ( WhatsApp enabled) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[6px] md:px-[11px] py-[8px]'>
                            <PhoneInput defaultCountry="in" value={number} onChange={(phone, country) => { setNumber(phone); setCountryCode(country?.country); setNumberError(''); }}
                                countrySelector={{
                                    showSearch: true,
                                    searchPlaceholder: "Search country...",
                                }}
                                className="max-h-[40px] sm:max-h-[60px] h-full w-full focus:outline-none cursor-pointer surge-form placeholder:text-[#000]" />
                        </div>
                        {numberError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{numberError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={yearIcon} alt='yearIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Year of Study ( 1st - 4th Year)  <span className='text-[#FF2D55]'>* </span> </div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={year} placeholder='Enter a current year' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setYear(e.target.value); setYearError("") }} />
                        </div>
                        {yearError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{yearError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 2 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-1 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#00C7BE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={graduationIcon} alt='graduationIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Year of Graduation <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px] md:h-[150px] overflow-y-scroll'>
                            {years.map((track, index) => (
                                <div key={index} className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${gradution === track ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`}
                                    onClick={() => {
                                        if (gradution === track) {
                                            setGradution("");
                                        } else {
                                            setGradution(track);
                                            setGradutionError("");
                                        }
                                    }}
                                >
                                    <div
                                        className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${gradution === track ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`} >
                                        <span className="font-bold">
                                            {String.fromCharCode(65 + index)}
                                        </span>
                                    </div>
                                    <h3 className="w-full text-start break-word text-[12px] sm:text-[18px]">
                                        {track}
                                    </h3>
                                </div>
                            ))}

                        </div>
                        {gradutionError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{gradutionError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#30B0C733] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={collegeIcon} alt='collegeIcon' className='w-[10px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>College Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={collegeName} placeholder='Enter college name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setCollegeName(e.target.value); setCollegeNameError('') }} />
                        </div>
                        {collegeNameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{collegeNameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#32ADE633] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={universityIcon} alt='universityIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>University Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={universityName} placeholder='Enter your university name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setUniversityName(e.target.value); setUniversityNameError('') }} />
                        </div>
                        {universityNameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{universityNameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={locationIcon} alt='locationIcon' className='w-[7px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Location <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={location} placeholder='Enter your location' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setLocation(e.target.value); setLocationError('') }} />
                        </div>
                        {locationError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{locationError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 3 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep3 ? "opacity-0 -translate-x-[300%]" : isStep2 ? "opacity-1 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#5856D633] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={degreeIcon} alt='degreeIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Degree Type ( BA/B Tech/MBA etc) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={degree} placeholder='Enter your degree' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setDegree(e.target.value); setDegreeError('') }} />
                        </div>
                        {degreeError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{degreeError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#AF52DE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={departmentIcon} alt='departmentIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Department <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={department} placeholder='Enter your department name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setDepartment(e.target.value); setDepartmentError('') }} />
                        </div>
                        {departmentError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{departmentError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF2D5533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={interestIcon} alt='interestIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Primary Interested Track <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px] md:h-[150px] overflow-y-scroll'>
                            {tracks.map((track, index) => (
                                <div key={index} className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${interestedTrack === track ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`}
                                    onClick={() => {
                                        if (interestedTrack === track) {
                                            setInterestedTrack("");
                                        } else {
                                            setInterestedTrack(track);
                                            setInterestedTrackError("");
                                        }
                                    }}
                                >
                                    <div
                                        className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${interestedTrack === track ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`} >
                                        <span className="font-bold">
                                            {String.fromCharCode(65 + index)}
                                        </span>
                                    </div>
                                    <h3 className="w-full text-start break-word text-[12px] sm:text-[18px]">
                                        {track}
                                    </h3>
                                </div>
                            ))}

                        </div>
                        {interestedTrackError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{interestedTrackError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#A2845E33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={experienceIcon} alt='experienceIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Experience level in Interested Track <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Beginner" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Beginner") { setExperience(""); } else { setExperience("Beginner"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Beginner" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Beginner</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Intermediate" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Intermediate") { setExperience(""); } else { setExperience("Intermediate"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Intermediate" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Intermediate</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Advanced" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Advanced") { setExperience(""); } else { setExperience("Advanced"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Advanced" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Advanced</h3>
                            </div>
                        </div>
                        {experienceError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{experienceError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 4 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep4 ? "opacity-0 -translate-x-[400%]" : isStep3 ? "opacity-1 -translate-x-[300%]" : isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={aimIcon} alt='aimIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>What are you currently aiming for? <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${aim === "Job" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (aim === "Job") { setAim(""); } else { setAim("Job"); setAimError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${aim === "Job" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Job</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${aim === "Higher Studies" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (aim === "Higher Studies") { setAim(""); } else { setAim("Higher Studies"); setAimError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${aim === "Higher Studies" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Higher Studies</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${aim === "Entrepreneurship" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (aim === "Entrepreneurship") { setAim(""); } else { setAim("Entrepreneurship"); setAimError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${aim === "Entrepreneurship" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Entrepreneurship</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${aim === "Still Exploring" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (aim === "Still Exploring") { setAim(""); } else { setAim("Still Exploring"); setAimError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${aim === "Still Exploring" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Still Exploring</h3>
                            </div>
                        </div>
                        {aimError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{aimError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={challengeIcon} alt='challengeIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Biggest challenge right now <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${challenge === "Lack of Clarity" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (challenge === "Lack of Clarity") { setChallenge(""); } else { setChallenge("Lack of Clarity"); setChallengeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${challenge === "Lack of Clarity" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Lack of Clarity</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${challenge === "Poor Communication" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (challenge === "Poor Communication") { setChallenge(""); } else { setChallenge("Poor Communication"); setChallengeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${challenge === "Poor Communication" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Poor Communication</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${challenge === "Skill Gap" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (challenge === "Skill Gap") { setChallenge(""); } else { setChallenge("Skill Gap"); setChallengeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${challenge === "Skill Gap" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Skill Gap</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${challenge === "Confidence" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (challenge === "Confidence") { setChallenge(""); } else { setChallenge("Confidence"); setChallengeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${challenge === "Confidence" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Confidence</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${challenge === "Direction" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (challenge === "Direction") { setChallenge(""); } else { setChallenge("Direction"); setChallengeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${challenge === "Direction" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>E</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Direction</h3>
                            </div>
                        </div>
                        {challengeError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{challengeError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={sessionIcon} alt='sessionIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Preferred Session Time <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "Saturday Morning" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "Saturday Morning") { setSession(""); } else { setSession("Saturday Morning"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "Saturday Morning" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Saturday Morning</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "Saturday Evening" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "Saturday Evening") { setSession(""); } else { setSession("Saturday Evening"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "Saturday Evening" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Saturday Evening</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "Sunday Morning" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "Sunday Morning") { setSession(""); } else { setSession("Sunday Morning"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "Sunday Morning" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Sunday Morning</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "Sunday Evening" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "Sunday Evening") { setSession(""); } else { setSession("Sunday Evening"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "Sunday Evening" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Sunday Evening</h3>
                            </div>
                        </div>
                        {sessionError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{sessionError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={consentIcon} alt='consentIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>We need a consent to receive communication on WhatsApp & Email <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${consent === "Yes, I agree" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (consent === "Yes, I agree") { setConsent(""); } else { setConsent("Yes, I agree"); setConsentError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${consent === "Yes, I agree" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes, I agree</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${consent === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (consent === "No") { setConsent(""); } else { setConsent("No"); setConsentError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${consent === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {consentError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{consentError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 4 ---- */}
                <div className={`w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll text-center ${isStep4 ? "opacity-1 -translate-x-[400%]" : isStep3 ? "opacity-1 -translate-x-[300%]" : isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <img src={ack} alt='ack' className='mx-auto size-[100px] md:size-[140px]' />
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-medium text-[18px] md:text-[30px]'>Also Acknowledgement that:</p>
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-medium text-[20px] md:text-[34px]'>Surge Students is a learning & mentorship program</p>
                    <p className='mt-[10px] md:mt-[20px] text-[#080808] font-bold text-[20px] md:text-[34px]'>No Job or Placement Guarantee</p>
                    <div className='flex gap-[7px] md:gap-[14px] items-center justify-center mt-[10px] md:mt-[20px] cursor-pointer' onClick={() => { setAcknowledge(!acknowledge) }}>
                        <div className={`${acknowledge ? "border-[2px] border-[#34C759]" : "border-[1px] border-[#646464]"} size-[16px] md:size-[24px] p-[2px] md:p-[4px] rounded-full transition-all duration-200`}>
                            {acknowledge && (
                                <div className='bg-[#34C759] size-full rounded-full'></div>
                            )}
                        </div>
                        <p className='text-[16px] md:text-[25px] font-medium'>Yes I agree</p>
                    </div>
                </div>
            </div>
            <div className='flex gap-[10px] md:gap-[20px] items-center justify-center flex-wrap'>
                <button disabled={!isStep1} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] border border-[#54545657] text-[#3C3C4399] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (isStep4) {
                            setIsStep4(false)
                        } else if (isStep3) {
                            setIsStep3(false)
                        } else if (isStep2) {
                            setIsStep2(false)
                        } else if (isStep1) {
                            setIsStep1(false)
                        }
                    }}>Back</button>
                <button disabled={isClicked} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] bg-[#34C759] text-[#FFFFFF] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (!isStep1) {
                            handleStep1()
                        } else if (!isStep2) {
                            handleStep2()
                        } else if (!isStep3) {
                            handleStep3()
                        } else if (!isStep4) {
                            handleStep4()
                        } else if (isStep4) {
                            handleStep5()
                        }
                    }}>Next</button>
            </div>
            {isSuccess && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[14px] p-[20px] relative text-center'>
                        <LuX className='text-[16px] md:text-[22px] cursor-pointer absolute top-[20px] right-[20px]'
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/"
                                }
                            }} />
                        <div className='font-medium text-[16px] md:text-[22px]'>
                            <p className='text-[#414141] text-center'>Automatically closing in</p>
                            <div className='size-[40px] md:size-[50px] mx-auto mt-[4px] md:mt-[7px] rounded-full border-[2px] border-[#34C759] flex justify-center items-center text-[#34C759]'>{timeLeft}</div>
                        </div>
                        <div className='mt-[12px] md:mt-[24px]'>
                            <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                                <LoadLottie animationData={isPaymentFailed ? Error : Tick} loop={true} />
                            </div>
                            <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>{isPaymentFailed ? "Payment Failed. Please try again." : "Congratulations your slot is booked successfully"}</p>
                            <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>{isPaymentFailed ? "Your slot wasn’t booked. If money was deducted, it’ll be refunded shortly." : "We sent the details in registered email."}</p>
                        </div>
                        <button className={`mt-[12px] md:mt-[24px] w-full h-[45px] md:h-[72px] rounded-[12px] md:rounded-[18px] text-[16px] md:text-[25px] font-semibold ${isPaymentFailed ? "bg-[#FFDD09] text-[#000000]" : "bg-[#34C759] text-[#F3F3F3]"}`}
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/"
                                }
                            }}>{isPaymentFailed ? "Try Again " : "Back to Home"}</button>
                    </div>
                </div>
            )}
        </div>
    )
}
